import { BodyPartChildOptionValueEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreBodyPart } from '@types';

const initialState: IStoreBodyPart = Object.fromEntries(
  Object.values(BodyPartChildOptionValueEnum).map((value) => [value, false])
);

export const bodyPartSlice = createSlice({
  name: 'bodyPart',
  initialState,
  reducers: {
    initBodyPart: () => {
      return initialState;
    },

    setBodyPart: (state, action: PayloadAction<IStoreBodyPart>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initBodyPart, setBodyPart } = bodyPartSlice.actions;

export default bodyPartSlice.reducer;
